// extracted by mini-css-extract-plugin
export var legendIndicator = "_eg-1";
export var legendRight = "_eg-0";